<mat-card appearance="outlined">
    <mat-card-header>
        <img mat-card-avatar [src]="vm.profileImageSrc" [alt]="vm.displayName" />
        <mat-card-title>{{vm.displayName}}</mat-card-title>
    </mat-card-header>

</mat-card>
